function InputLabel(props) {
    return (
        <label className="form-label">{props.text}</label>
    );
}

export default InputLabel;